import {getImage} from '@dazn/lp-web/src/utils/commonUtils';
import {ComponentTypes} from '@dazn/lp-web/src/constants/componentTypes.constants';
import {buttonProxy} from '@dazn/lp-web/src/proxies/button.proxy';

export function subscriptionsRailProxy(component: any): any {
    const componentType = component?.fields?.componentType;
    const title = component?.fields?.title;
    const description = component?.fields?.description;
    const tiles = component?.fields?.entries?.map((entry: any) => {
        const {
            description,
            badgeText,
            showBadge,
            backgroundImage,
            buttons,
            logo
        } = entry?.fields ?? {};
        return {
            description,
            badgeText,
            showBadge,
            image: getImage(backgroundImage),
            button: buttonProxy(buttons?.[0]?.fields),
            logo: getImage(logo)
        };
    });
    return {
        title,
        description,
        componentType,
        tiles,
        railType: ComponentTypes.SUBSCRIPTIONS_RAIL
    };
}
